// Route for the variant-specific URL.
// Shape is frozen in ARCHITECTURE.md §4: /product/{slug}/{variant-slug}.
// The {lang} prefix is kept per the existing i18n pattern (defer F-13).
export default '/@lang/product/@slug/@variantSlug'
